import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import unorm from 'unorm';
import $ from 'jquery';
import LoadingModal from '../loadingModal';
import CircularIndicator from '../indicators/circularIndicator';

import { Map, Marker, Tooltip, TileLayer } from 'react-leaflet-universal';
import { ContentRemoveCircle } from 'material-ui/svg-icons';

let L;
export default class Modal extends Component {
  constructor() {
    super();
    this.state = { showMap: false, icon: '' };
  }

  componentDidMount() {
    L = require('leaflet');
    const myIcon = L.divIcon({
      className: 'my-div-icon'
    });
    this.setState({ showMap: true, icon: myIcon });
  }
  goSection = e => {
    e.preventDefault();
    const imgs = document.querySelectorAll('[data-img]');
    imgs.forEach(input => {
      input.classList.remove('image-open');
    });
    document.getElementById(e.target.dataset.id).classList.add('image-open');
    if ($(`#${e.target.dataset.id}`).length > 0) {
      $('.box-modal').animate(
        {
          scrollTop: $(`#${e.target.dataset.id}`).position().top + $(`.box-modal`).scrollTop() - 40
        },
        1000
      );
    }
  };

  colorSeverity = (arr, type) => {
    // formatting process to be able to find the element in the array
    let str = type;
    str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
    str = str.toLowerCase();
    const obj = arr.find(o => o.key === str);
    if (obj) {
      return `5px solid ${obj.color}`;
    }
    return '#000000';
  };

  translate = (arr, type, language) => {
    // formatting process to be able to find the element in the array
    let str = type;
    str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
    str = str.toLowerCase();
    const obj = arr.find(o => o.key === str);
    return obj ? obj[`${language}Name`] : '';
  };

  dateSelect = (item, type) => {
    if (type === 1 || type === '1') {
      return moment(item.creationDate.substring(0, 19)).format('DD-MM-YY H:mm:ss');
    } else if (type === 2 || type === '2') {
      return moment(item.mobileDate.substring(0, 19)).format('DD-MM-YY H:mm:ss');
    }
  };

  fails = (type, fails) => {
    if(fails==null) {
      return "";
    }
    let value;
    if (fails.toLowerCase() === 'sin fallas') {
      value =
        type.toLowerCase() === 'photo' || type.toLowerCase() === 'sign' ? '' : fails.toLowerCase();
    } else {
      value = fails.toLowerCase();
    }
    return value;
  };

  dateValidator = valor => {
    if (valor) {
      if (valor.split('-').length >= 3) {
        if (moment(valor).isValid()) {
          return moment(valor).format('DD-MM-YYYY');
        }
      }
    }
    return valor;
  };

  printDocument = e => {
    e.preventDefault();
    if (!this.props.fullscreen) {
      $('#inspection-modal .container-modal-right').addClass('resizemap');
      this.leafletMap.invalidateSize();
      setTimeout(
        function() {
          var content = document.getElementById('inspection-modal').innerHTML;
          $('body').append("<section id='print-section'>" + content + '</section>');
          $('#inspection-modal .container-modal-right').removeClass('resizemap');
          $('#inspection-modal').addClass('printing');
          window.print();
          $('#inspection-modal').removeClass('printing');
          $('body>#print-section').remove();
        }.bind(this),
        200
      );
    } else {
      window.print();
    }
    return true;
  };

  leafletRefAvailable(ref) {
    if (ref) {
      this.leafletMap = ref.leafletElement;
    }
  }

  render() {
    if (this.state.showMap) {
      let container;
      if (this.props.loading) {
        container = <LoadingModal height="modal-inspections" />;
      } else {
        container = (
          <section data-fix="ok">
            <div data-fix="ok" className="modal-right--content">
              <div data-fix="ok" className="modal-inspection">
                <div data-fix="ok" className="modal-inspection--title flex">
                  <div data-fix="ok" className="modal-inspection--title--a">
                    Resumen de información
                  </div>
                  <a data-fix="ok" className="download-pdf" onClick={this.printDocument}>
                    Descargar PDF
                  </a>
                  <div data-fix="ok" className="modal-inspection--title--b">
                    <a data-fix="ok">{/* <i className="fas fa-file-pdf" /> */}</a>
                  </div>
                </div>
                <div data-fix="ok" className="modal-inspection--content-graph">
                  <div data-fix="ok" className="modal-inspection--list">
                    <ul data-fix="ok">
                      <li data-fix="ok">
                        <strong data-fix="ok">Fecha:</strong>
                        {this.dateSelect(this.props.datos, this.props.main)}
                      </li>
                      <li data-fix="ok">
                        <strong data-fix="ok">Inspector:</strong> {this.props.datos.supervisor}
                      </li>
                      <li data-fix="ok">
                        <strong data-fix="ok">Formulario:</strong> {this.props.datos.formName}
                      </li>
                      <li data-fix="ok">
                        <strong data-fix="ok">Transportista:</strong> {this.props.datos.carrier}
                      </li>
                      <li data-fix="ok">
                        <strong data-fix="ok">Conductor:</strong> {this.props.datos.driver}
                      </li>
                      <li data-fix="ok">
                        <strong data-fix="ok">Vehículo:</strong> {this.props.datos.equipment}
                      </li>
                    </ul>
                  </div>
                  {this.props.datos.score !== null && (
                    <div data-fix="ok" className="modal-inspection--contentcirucular">
                      <div data-fix="ok" className="modal-inspection--circular">
                        <CircularIndicator
                          data-fix="ok"
                          size={110}
                          max={100}
                          value={this.props.datos.score === null ? null : this.props.datos.score}
                          graphColorRange={{
                            higherRisk: [0, 40],
                            middleRisk: [40, 60],
                            outOfRisk: [60, null]
                          }}
                        />
                        <h4 data-fix="ok">Nota</h4>
                      </div>
                    </div>
                  )}
                  {this.props.datos.score !== null && (
                    <div data-fix="ok" className="modal-inspection--fourcirucular">
                      {this.props.datos.fails.map((item, i) => (
                        <div data-fix="ok" key={i} className="flex">
                          <h5
                            data-fix="ok"
                            style={{
                              border: this.colorSeverity(
                                this.props.severityFailsColor,
                                item.severityType
                              )
                            }}
                          >
                            <strong>{item.value === null ? 'N/A' : item.value}</strong>
                          </h5>
                          <p data-fix="ok">
                            {this.translate(
                              this.props.severityFailsColor,
                              item.severityType,
                              this.props.languageFormat
                            )}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                  {this.props.datos.score === null && (
                    <div data-fix="ok" className="modal-inspection--score">
                      <h2>No Aplica</h2>
                      <h3>Nota</h3>
                    </div>
                  )}
                </div>
                <div data-fix="ok" className="modal-inspection--titles">
                  Ubicación
                </div>
                <div
                  data-fix="ok"
                  className="modal-inspection--map"
                  id="modal-inspection--map"
                  style={{ width: '100%' }}
                >
                  {
                    <Map
                      data-fix="ok"
                      leafletRef={ref => this.leafletRefAvailable(ref)}
                      center={[this.props.datos.latitud, this.props.datos.longitud]}
                      zoom={13}
                    >
                      {() => {
                        return (
                          <div data-fix="ok">
                            <TileLayer
                              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                            />
                            <Marker
                              position={[this.props.datos.latitud, this.props.datos.longitud]}
                              icon={this.state.icon}
                            />
                          </div>
                        );
                      }}
                    </Map>
                  }
                </div>
                <div data-fix="ok" className="modal-inspection--titles bot">
                  Respuesta Formulario: {this.props.datos.formName}
                </div>
                {this.props.question &&
                  this.props.question.questions.map((item, i) => (
                    <div data-fix="ok" key={i} className="modal-inspection--table top">
                      <h3 data-fix="ok">{item.title ? item.title : 'Datos'}</h3>
                      <table data-fix="ok">
                        <thead data-fix="ok">
                          <tr data-fix="ok">
                            <th className="left" data-fix="ok">
                              Pregunta
                            </th>
                            <th data-fix="ok">Respuesta</th>
                            <th className="left" data-fix="ok">
                              Consideraciones
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.items.map((val, e) => {
                            if (!this.props.loadingImg) {
                              if (Array.isArray(this.props.datosImg)) {
                                let obj = this.props.datosImg.findIndex(
                                  o => o.questionCode === val.code
                                );
                                if (obj >= 0) {
                                  this.props.datosImg[obj].title = val.question;
                                }
                              }
                            }

                            return (
                              <tr
                                data-fix="ok"
                                key={e}
                                className={
                                  val.fail == null
                                    ? `${val.type}`
                                    : `${val.type} ${unorm
                                        .nfd(val.fail)
                                        .replace(/[\u0300-\u036f]/g, '')}`
                                }
                              >
                                <td data-fix="ok">
                                  <a
                                    data-fix="ok"
                                    role="button"
                                    tabIndex={0}
                                    onClick={this.goSection}
                                    data-id={`${val.code}`}
                                  >
                                    {val.question}{' '}
                                  </a>
                                </td>
                                <td className="center" data-fix="ok">
                                  <a
                                    data-fix="ok"
                                    role="button"
                                    tabIndex={0}
                                    onClick={this.goSection}
                                    data-id={`${val.code}`}
                                  >
                                    {this.dateValidator(val.value)}{' '}
                                  </a>
                                </td>
                                <td data-fix="ok">
                                  <a
                                    className={"capital" + (val.isError ? " hasError" : "")}
                                    data-fix="ok"
                                    role="button"
                                    tabIndex={0}
                                    onClick={this.goSection}
                                    data-id={`${val.code}`}
                                  >
                                    {this.fails(val.type, val.fail)}{' '}
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ))}
                {!this.props.loadingImg && this.props.statusImg === 200 ? (
                  <div data-fix="ok" className="modal-img">
                    <h3 data-fix="ok">Imágenes</h3>
                    {this.props.datosImg.map((item, i) => {
                      return (
                        <div data-fix="ok" key={i}>
                          <h4>{item.title ? item.title : ''}</h4>
                          <img
                            data-fix="ok"
                            data-img="all-img"
                            id={item.questionCode}
                            src={`data:image/png;base64,${item.image}`}
                            alt="prueba"
                          />
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div data-fix="ok" className="modal-img">
                    <h3>Imágenes</h3>
                  </div>
                )}
              </div>
            </div>
          </section>
        );
      }
      return (
        <section id={'inspection-modal'}>
          <div
            data-fix="ok"
            className={
              this.props.modalRight ? `modal-right--title-new` : `modal-right--title-new hide`
            }
          >
            <h2 data-fix="ok">{this.props.datos.formName}</h2>
            <a data-fix="ok">
              <i
                data-fix="ok"
                role="button"
                tabIndex={0}
                onClick={this.props.handleModal}
                className="close fas fa-times-circle"
              />
            </a>
          </div>
          <div
            data-fix="ok"
            className={
              this.props.modalRight ? `container-modal-right` : `container-modal-right hide`
            }
          >
            <div className="box-modal" id="modal-inspections">
              {container}
            </div>
          </div>
        </section>
      );
    }
    return (
      <div
        data-fix="ok"
        className={this.props.modalRight ? `container-modal-right` : `container-modal-right hide`}
      >
        <div data-fix="ok" className="box-modal" id="modal-inspections" />
      </div>
    );
  }
}

Modal.defaultProps = {
  datos: {}
};

Modal.propTypes = {
  loading: PropTypes.bool.isRequired,
  datos: PropTypes.oneOfType([PropTypes.object])
};



// WEBPACK FOOTER //
// ./source/client/components/common/inspections/modal.jsx